import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import DateRange from './DateRange';

const propTypes = exact({
  title: PropTypes.string,
  fromDate: PropTypes.string,
  toDate: PropTypes.string,
  description: PropTypes.string,
  secondDescription: PropTypes.string,
  showAtolLabel: PropTypes.bool,
  atolProtectedText: PropTypes.string,
});

const defaultProps = {
  title: '',
  fromDate: null,
  toDate: null,
  description: null,
  secondDescription: null,
  showAtolLabel: false,
  atolProtectedText: null,
};

function SummaryContent(props) {
  return (
    <>
      {props.title && <h3 className="PackageSummary_title">{props.title}</h3>}
      {props.fromDate && props.toDate && (
        <DateRange fromDate={props.fromDate} toDate={props.toDate} />
      )}
      {props.description && <div className="PackageSummary_description">{props.description}</div>}
      {props.secondDescription && (
        <div className="PackageSummary_description">{props.secondDescription}</div>
      )}
      {props.showAtolLabel && (
        <div className="PackageSummary_atolLabel">{props.atolProtectedText}</div>
      )}
    </>
  );
}

SummaryContent.propTypes = propTypes;
SummaryContent.defaultProps = defaultProps;

export default SummaryContent;
